/**
 * StageHudView — WOOD balance (the brag stat: rises with energy you build,
 * falls when the AI drains it), energy reserve / survival clock, lives.
 */

import { FONT_SIZE, fontStyle } from "../FontScale";
import { fitText, isNarrow } from "../view/layout";

const HUD_TOP = 32;
const HUD_BOT = 28;
const fmt = (n) => Math.floor(n).toLocaleString("en-US");

export function createStageHud(scene, { level, kind, pal }) {
  const W = scene._W;
  const H = scene._H;
  const hud = {};
  const bar = scene.add.graphics().setDepth(100);
  bar.fillStyle(pal.hudBg, 1);
  bar.fillRect(0, 0, W, HUD_TOP);
  bar.fillRect(0, H - HUD_BOT, W, HUD_BOT);
  bar.lineStyle(2, kind === "build" ? 0x7bc74a : 0xff00ff);
  bar.lineBetween(0, HUD_TOP, W, HUD_TOP);
  bar.lineBetween(0, H - HUD_BOT, W, H - HUD_BOT);

  scene.add.text(8, 4, "WOOD", fontStyle(FONT_SIZE.CAPTION, "#D4884A")).setDepth(101);
  hud.wood = scene.add.text(8, 16, "0", fontStyle(FONT_SIZE.BODY, "#FFD84A")).setDepth(101);

  const title = `STAGE ${level} · ${kind === "build" ? "SOLARPUNK BUILD" : "NEON DEFEND"}`;
  fitText(
    scene.add
      .text(W / 2, 4, title, fontStyle(FONT_SIZE.CAPTION, kind === "build" ? "#7BC74A" : "#FF00FF"))
      .setOrigin(0.5, 0)
      .setDepth(101),
    W * 0.5,
  );
  hud.lives = scene.add.text(W / 2, 18, "", fontStyle(FONT_SIZE.CAPTION, "#FFFFFF")).setOrigin(0.5, 0).setDepth(101);

  hud.energyLabel = scene.add
    .text(W - 8, 4, kind === "build" ? "RESERVE" : "TIME", fontStyle(FONT_SIZE.CAPTION, "#00FFFF"))
    .setOrigin(1, 0)
    .setDepth(101);
  hud.energy = scene.add.text(W - 8, 16, "", fontStyle(FONT_SIZE.BODY, "#FFFFFF")).setOrigin(1, 0).setDepth(101);

  hud.drain = scene.add
    .text(W / 2, HUD_TOP + 6, "", fontStyle(FONT_SIZE.BODY, "#FF3333", { stroke: "#000000", strokeThickness: 3 }))
    .setOrigin(0.5, 0)
    .setDepth(101);

  if (!isNarrow(scene)) {
    fitText(
      scene.add
        .text(W / 2, H - HUD_BOT + 9, "←→ MOVE   ↑↓ CLIMB   SPACE JUMP   W / C CHUCK WOOD", fontStyle(FONT_SIZE.CAPTION, "#AAAAAA"))
        .setOrigin(0.5, 0)
        .setDepth(101),
      W - 80,
    );
  }
  return hud;
}

export function updateStageHud(hud, sim) {
  const cfg = sim.config;
  const bank = Math.max(0, sim.bankWh);
  hud.wood.setText(`${fmt(bank / cfg.whPerLog)} LOGS`);
  hud.lives.setText("♥".repeat(Math.max(0, sim.lives))); // lives carry across stages (arcade credits)
  if (sim.kind === "build") {
    hud.energy.setText(`${fmt(sim.reserveWh)} Wh`);
    hud.energy.setFill(sim.reserveWh < cfg.reserveWh * 0.25 ? "#FF3333" : "#FFFFFF");
    hud.drain.setText("");
  } else {
    const secs = Math.max(0, Math.ceil((cfg.surviveTicks - sim.tick) / 50));
    hud.energy.setText(`${secs}s`);
    const leak =
      sim.leeches.length * cfg.leechDrainWhPerSec +
      sim.ladders.filter((l) => l.cracked && l.rungs < l.need).length * cfg.crackLeakWhPerSec;
    hud.drain.setText(leak > 0 ? `AI DRAIN  -${fmt(leak / cfg.whPerLog)} LOGS/S` : "");
  }
}
